import type { LandingPageContent } from './types'

// GitLab-Issue #147: eigener, schlanker Auftragstyp/Landingpage für Kunden, die ihre PV-Anlage
// komplett selbst montiert haben und nur noch die formale VDE-Abnahme und die Anmeldung beim
// Netzbetreiber brauchen - bewusst abgegrenzt von der bestehenden photovoltaik-elektroinstallation
// (tatsächliche Elektroinstallationsleistung) und von Balkonkraftwerk/Stecker-Solar (andere
// Rechtslage, siehe FAQ unten). DE-only (siehe index.test.ts MULTI_LANG_TOPIC_IDS-Ausnahme,
// analog zum B2B-Howto-Topic): VDE-Abnahme/Netzbetreiber-Anmeldung sind deutsche Regularien, eine
// wörtliche Übersetzung für ES/PL wäre fachlich irreführend statt nur unübersetzter UI-Chrome.
export const PHOTOVOLTAIK_ABNAHME_ANMELDUNG: LandingPageContent = {
  slug: 'photovoltaik-abnahme-anmeldung',
  lang: 'de',
  topicId: 'photovoltaik-abnahme-anmeldung',
  title: 'PV-Anlage selbst montiert - Abnahme & Anmeldung vom Elektriker',
  metaDescription:
    'Solaranlage komplett selbst montiert? Fragen Sie nur die VDE-Abnahme und die Anmeldung beim ' +
    'Netzbetreiber an - ohne kompletten Installationsauftrag.',
  keywords: [
    'Photovoltaik Abnahme',
    'PV Anlage anmelden Elektriker',
    'Elektriker für Abnahme Photovoltaik',
    'Solaranlage selbst montiert Elektriker',
    'VDE Abnahme PV Kosten',
    'Netzbetreiber Anmeldung Photovoltaik',
  ],
  eyebrow: 'Nur Abnahme & Anmeldung',
  h1: 'PV-Anlage selbst montiert - jetzt Abnahme & Anmeldung anfragen',
  intro:
    'Sie haben Ihre Photovoltaik-Anlage komplett in Eigenleistung montiert und angeschlossen? Für die ' +
    'formale VDE-Abnahme und die Anmeldung beim Netzbetreiber braucht es trotzdem einen eingetragenen ' +
    'Elektrofachbetrieb. Bei Roofora fragen Sie genau diese Leistung an - ohne einen kompletten ' +
    'Installationsauftrag auszuschreiben, den Sie gar nicht brauchen.',
  sections: [
    { type: 'heading', text: 'Für wen sich diese Anfrage lohnt' },
    {
      type: 'list',
      items: [
        'Die komplette Dachanlage (Module, Verkabelung, Wechselrichter) ist bereits von Ihnen selbst montiert und angeschlossen',
        'Es fehlt nur noch die formale VDE-Abnahme durch einen Elektrofachbetrieb',
        'Die Anmeldung und Inbetriebnahme beim Netzbetreiber steht noch aus',
        'Wichtig: Diese Anfrage richtet sich an vollständige Dach-/Aufständerungsanlagen, nicht an ' +
          'steckerfertige Balkonkraftwerke - für die gelten andere, meist einfachere Anmelderegeln',
      ],
    },
    { type: 'heading', text: 'Was zur Abnahme & Anmeldung dazugehört' },
    {
      type: 'list',
      items: [
        'Fachliche Prüfung Ihrer Eigenmontage nach VDE-Vorgaben (Abnahmeprotokoll)',
        'Übernahme der formalen Verantwortung für den elektrischen Teil der Anlage',
        'Anmeldung und Inbetriebnahmemeldung bei Ihrem Netzbetreiber',
        'Bei Bedarf: Hinweise auf Nachbesserungen, falls die Eigenmontage bei der Prüfung Auffälligkeiten zeigt',
      ],
    },
    { type: 'heading', text: 'So läuft die Anfrage ab' },
    {
      type: 'paragraph',
      text:
        'Sie geben nur die installierte Anlagengröße in kWp an und können in einem Freitextfeld ' +
        'Speichergröße, Hersteller oder Besonderheiten ergänzen. Elektrofachbetriebe sehen Ihre ' +
        'anonymisierte Anfrage und geben unverbindliche Angebote nur für Abnahme und Anmeldung ab - ' +
        'kein aufwändiger Vor-Ort-Termin zur Angebotserstellung nötig.',
    },
    { type: 'heading', text: 'Kontakt erst nach Ihrer Freigabe' },
    {
      type: 'paragraph',
      text:
        'Wie bei jedem Auftragstyp bei Roofora entsteht Kontakt erst, wenn Sie einen einzelnen Betrieb ' +
        'individuell freigeben - keine Sammelfreigabe, keine Anruf-Flut.',
    },
  ],
  faq: [
    {
      q: 'Muss die Abnahme zwingend durch einen Elektrofachbetrieb erfolgen, auch wenn ich alles selbst montiert habe?',
      a: 'Ja - die formale VDE-Abnahme und die Anmeldung beim Netzbetreiber dürfen in Deutschland nur ' +
        'von einem eingetragenen Elektrofachbetrieb vorgenommen werden, unabhängig davon, wer die Anlage montiert hat.',
    },
    {
      q: 'Ist diese Anfrage auch für ein Balkonkraftwerk geeignet?',
      a: 'Nein - diese Anfrage richtet sich an vollständige Dach-/Aufständerungsanlagen. Für ' +
        'steckerfertige Balkonkraftwerke gelten eigene, meist einfachere Anmelderegeln.',
    },
    {
      q: 'Was passiert, wenn bei der Abnahme Mängel an meiner Eigenmontage festgestellt werden?',
      a: 'Der Elektrofachbetrieb weist Sie auf notwendige Nachbesserungen hin, bevor die Anlage formal ' +
        'abgenommen und angemeldet wird - die konkrete Nachbesserung selbst ist nicht Teil dieses schlanken Auftragstyps.',
    },
  ],
  primaryCta: { label: 'Abnahme & Anmeldung anfragen', action: 'customer' },
  secondaryCta: { label: 'Doch mehr Elektroarbeiten nötig?', action: 'link', href: '/photovoltaik-elektroinstallation' },
  relatedLinks: [
    { label: 'Photovoltaik-Elektroinstallation fachgerecht anschließen', href: '/photovoltaik-elektroinstallation' },
    { label: 'PV-Installateur finden', href: '/pv-installateur-finden' },
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
  ],
}
